// Tiny square-wave blips, generated on the fly. Off by default; turning it on is
// remembered for that visitor. Browsers only allow audio after a user gesture, so a
// returning visitor with sound on hears nothing until their first click, tap or key.
let ctx = null

// A short burst of noise: the thud of a glove landing.
function thump() {
  if (!ctx) return
  const t0 = ctx.currentTime
  const len = Math.floor(ctx.sampleRate * 0.12)
  const buffer = ctx.createBuffer(1, len, ctx.sampleRate)
  const data = buffer.getChannelData(0)
  for (let i = 0; i < len; i++) data[i] = (Math.random() * 2 - 1) * (1 - i / len) ** 2
  const src = ctx.createBufferSource()
  const filter = ctx.createBiquadFilter()
  const g = ctx.createGain()
  src.buffer = buffer
  filter.type = 'lowpass'
  filter.frequency.value = 900
  g.gain.value = 0.35
  src.connect(filter).connect(g).connect(ctx.destination)
  src.start(t0)
}

function tone(freqs, { dur = 0.08, type = 'square', gain = 0.05 } = {}) {
  if (!ctx) return
  const t0 = ctx.currentTime
  freqs.forEach((f, i) => {
    const osc = ctx.createOscillator()
    const g = ctx.createGain()
    osc.type = type
    osc.frequency.value = f
    const start = t0 + i * dur
    g.gain.setValueAtTime(gain, start)
    g.gain.exponentialRampToValueAtTime(0.0001, start + dur * 1.6)
    osc.connect(g).connect(ctx.destination)
    osc.start(start)
    osc.stop(start + dur * 1.8)
  })
}

const STORAGE_KEY = 'davie-sound'

function readPref() {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'on'
  } catch (e) {
    return false
  }
}
function writePref(on) {
  try {
    localStorage.setItem(STORAGE_KEY, on ? 'on' : 'off')
  } catch (e) {
    // Storage can be unavailable (private mode); the toggle still works for this visit.
  }
}

function unlock() {
  ctx = ctx || new (window.AudioContext || window.webkitAudioContext)()
  if (ctx.state === 'suspended') ctx.resume()
}

// Start the audio context on the first real user gesture.
['pointerdown', 'keydown', 'touchstart'].forEach((type) =>
  window.addEventListener(type, unlock, { once: true, passive: true }))

export const sound = {
  enabled: readPref(),
  enable() {
    unlock()
    this.enabled = true
    writePref(true)
    this.coin()
  },
  disable() {
    this.enabled = false
    writePref(false)
  },
  coin() {
    if (this.enabled) tone([988, 1319], { dur: 0.07 })
  },
  punch() {
    if (!this.enabled) return
    thump()
    setTimeout(() => this.coin(), 120)
  },
  jump() {
    if (this.enabled) tone([392, 523, 659], { dur: 0.04, gain: 0.035 })
  },
  clear() {
    if (this.enabled) tone([523, 659, 784, 1047, 784, 1047], { dur: 0.1, gain: 0.04 })
  },
}
